import Page from "../page/page";
import SettingIcon from "../../../assets/icon/svg/settings";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { setSubMenu } from "../../../store/action/subMenuAction";
import { menus, subMenus } from "../../../routers/menu";
import { regexUrlMatch } from "../../../services/helpers/Helper";
import { Popover } from "react-tiny-popover";
import Settings from "../components/setting";
import ItemMenu from "./item-menu";

const Menu = (props) => {
   const { setSubMenu } = props;
   const location = useLocation();
   const [isOpenSetting, setIsOpenSetting] = useState(false);
   const [isShowTooltip, setIsShowTooltip] = useState(false);

   useEffect(() => {
      const sub = subMenus.find(f => regexUrlMatch(f.match, location.pathname));
      setSubMenu(sub ? sub : []);
   }, [location.pathname]);

   return (
      <div className="app-messaging-first--nav-link ">
         <ul className="app-messaging-first--nav-list--top app-scrollbar">
            <li className="app-messaging-first--nav-link-item menu_pages" >
               <Page />
            </li>
            {menus.map((item, index) => (<ItemMenu key={index} {...item} />))}
         </ul>
         {/* <a className="app-messaging-first--account--settings" href="/settings"></a> */}
         <ul className="app-messaging-first--nav-list--bottom">
            {/* <li className="app-messaging-first--nav-link-item">
               <div className="app-messaging-first--nav-link-item--icon">
                  <div className="announcekit-widget app-messaging-first--nav-link-item app-messaging-first--badge vt-relative" data-announcekit-mode="badge">
                     <Notification />
                  </div>
               </div>
            </li>
            <li className="app-messaging-first--nav-link-item app-messaging-first--nav-link-item--support">
               <div className="app-messaging-first--nav-link-item--icon app-messaging-first--support--icon">
                  <span>
                     <Support />
                  </span>
               </div>
            </li> */}
            <li className="app-messaging-first--nav-link-item app-messaging-first--nav-link-item--settings">
               <Popover
                  isOpen={isOpenSetting}
                  align={'center'}
                  positions={['top', 'bottom', 'left', 'right']}
                  onClickOutside={() => setIsOpenSetting(false)}
                  clickOutsideCapture={true}
                  content={<Settings onClose={() => setIsOpenSetting(false)} />}
               >
                  <Popover
                     isOpen={isShowTooltip}
                     align={'center'}
                     positions={['right', 'bottom']}
                     clickOutsideCapture={true}
                     content={<div className="app-tooltip app-messaging-first-tooltip app-tooltip-placement-right" style={{ marginTop: -15 }}>
                        <div className="app-tooltip-content">
                           <div className="app-tooltip-arrow"></div>
                           <div className="app-tooltip-inner" role="tooltip">Tài khoản</div>
                        </div>
                     </div>}
                  >
                     <div className="app-messaging-first--menu-item--account"
                        onClick={() => setIsOpenSetting(!isOpenSetting)}
                        onMouseLeave={() => setIsShowTooltip(false)}
                        onMouseEnter={() => setIsShowTooltip(true)}>
                        <div className="app-messaging-first--menu-item--accounts-setting">
                           <span>
                              <SettingIcon />
                              <span className="app-messaging-first--red_dot app-messaging-first-rd-settings"></span>
                           </span>
                        </div>
                     </div>
                  </Popover>
               </Popover>
            </li>
         </ul>
      </div >
   );
}

const mapStateToProps = (state) => {
   return {};
};

export default connect(mapStateToProps, {
   setSubMenu
})(Menu);